import { render } from "./subpartC03.vue?vue&type=template&id=97b6ef26"
import script from "./subpartC03.vue?vue&type=script&lang=js"
export * from "./subpartC03.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__